import { useEffect } from 'react';
import Button from './Button.jsx';

export default function Modal({ open, onClose, title, children, footer, maxWidth = 'max-w-md' }) {
  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className={`relative z-10 w-full ${maxWidth} bg-bg-surface border border-border rounded-xl shadow-2xl flex flex-col max-h-[90vh]`}>
        {/* Header — siempre visible */}
        <div className="shrink-0 flex items-center justify-between px-5 py-4 border-b border-border">
          <h3 className="font-semibold text-slate-100">{title}</h3>
          <button onClick={onClose} className="text-slate-400 hover:text-white text-xl leading-none">&times;</button>
        </div>
        {/* Content — scrolleable */}
        <div className="flex-1 overflow-y-auto px-5 py-4 space-y-3">{children}</div>
        {/* Footer — siempre visible */}
        {footer && <div className="shrink-0 px-5 py-3 border-t border-border flex justify-end gap-2">{footer}</div>}
      </div>
    </div>
  );
}
